import React from "react";
import PropTypes from "prop-types";
import ErrorBoundary from "../error_boundary";
import GetQwotedCTA from "../profiles/GetQwotedCTA";
import MediaOutlet from "./MediaOutlet";
import { MediaOutletProvider } from "./data/media_outlet_context_management";

// Registered entry point for the Media Outlet show page (mirrors the other TopLevelShow wrappers):
// provider + error boundary around the show. The ERB mounts this component by name.
function MediaOutletTopLevelShow({ mediaOutletId, viewerContext = undefined }) {
  const contextValue = { viewerContext };

  return (
    <MediaOutletProvider value={contextValue}>
      <ErrorBoundary>
        <MediaOutlet mediaOutletId={mediaOutletId} />
      </ErrorBoundary>
      {!viewerContext?.isAuthenticated && <GetQwotedCTA />}
    </MediaOutletProvider>
  );
}

MediaOutletTopLevelShow.propTypes = {
  mediaOutletId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  viewerContext: PropTypes.shape({
    editable: PropTypes.bool,
    isSelf: PropTypes.bool,
    isAuthenticated: PropTypes.bool,
    role: PropTypes.string,
  }),
};

export default MediaOutletTopLevelShow;
